<template>
  <section class="accounting-code-page">
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-5 col-sm-12">
          <div class="card shadow border-0 rounded-3">
            <div class="card-body p-4">
              <h2 class="h5 mb-3 text-center">Accès Comptabilité</h2>
              <p class="text-muted small text-center mb-4">
                Entrez le code secret pour accéder aux factures, remboursements, encaissements et rapports.
              </p>
              <form @submit.prevent="submitCode">
                <div class="mb-3">
                  <label for="accountingCode" class="form-label">Code secret</label>
                  <input
                    id="accountingCode"
                    v-model="code"
                    type="password"
                    class="form-control"
                    placeholder="Code"
                    autocomplete="off"
                    :disabled="loading"
                  />
                </div>
                <div v-if="error" class="alert alert-danger py-2 small mb-3">{{ error }}</div>
                <div class="d-grid">
                  <button type="submit" class="btn btn-primary" :disabled="loading || !code.trim()">
                    {{ loading ? 'Vérification...' : 'Accéder' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'

export default {
  name: 'AccountingCode',
  data() {
    return {
      code: '',
      loading: false,
      error: ''
    }
  },
  methods: {
    async submitCode() {
      this.error = ''
      if (!this.code.trim()) return
      this.loading = true
      try {
        const { data } = await axios.post('/api/v1/admin/verify-accounting-code/', {
          code: this.code.trim()
        })
        this.$store.commit('setAccountingToken', data.accounting_token)
        const next = this.$route.query.next || '/invoices'
        this.$router.push(next)
      } catch (err) {
        const msg = err.response?.data?.error || 'Code invalide.'
        this.error = msg
        toast({
          message: msg,
          type: 'is-danger',
          dismissible: true,
          duration: 3000,
          position: 'top-right'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.accounting-code-page {
  min-height: 60vh;
  padding-bottom: 3rem;
}
</style>
